import React from 'react';
import PropTypes from 'prop-types';

import { CheckboxCell } from './';

const CheckboxRow = ({
  survivingCustomer,
  duplicates,
  onCheckboxChange,
  cellClassName,
  descriptor,
  disabled,
  selectedIndices,
}) => (
  <div className="c-table-card__row">
    <div className="c-table-card__cell u-2/12">
      <div>{descriptor.title}</div>
    </div>
    <div className="c-table-card__cell u-3/12">
      <div>
        {
          descriptor.formatter ?
            descriptor.formatter(survivingCustomer[descriptor.accessor], survivingCustomer) :
            survivingCustomer[descriptor.accessor]
        }
      </div>
    </div>
    {
      duplicates.map((d, idx) => (
        <div className={cellClassName}>
          <CheckboxCell
            key={d.id}
            idx={idx}
            selectedIndices={selectedIndices}
            accessor={descriptor.accessor}
            customer={d}
            onChange={onCheckboxChange}
            disabled={disabled}
            formatter={descriptor.formatter}
          />
        </div>
      ))
    }
  </div>
);

CheckboxRow.propTypes = {
  survivingCustomer: PropTypes.object.isRequired,
  duplicates: PropTypes.array.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  cellClassName: PropTypes.string,
  descriptor: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  selectedIndices: PropTypes.object.isRequired,
};

CheckboxRow.defaultProps = {
  cellClassName: '',
};

export default CheckboxRow;
